import { PageTitle } from "@components/PageTitle/PageTitle";
import { Sections } from "@components/Sections/Sections";
import React from "react";
import tw from "twin.macro";
import ArticleFooter from "./ArticleFooter";
import { ArticleOutputProps, withArticle } from "./withArticle";

const DateLabel = tw.p`
  uppercase py-maxi opacity-70
`;

export const Article = withArticle(
  ({
    title,
    paths,
    date,
    content,
    next,
    previous,
    shareImage,
    summary,
  }: ArticleOutputProps) => (
    <>
      <PageTitle title={title} background="lightest" paths={paths}>
        {date ? <DateLabel>{date}</DateLabel> : null}
      </PageTitle>
      <Sections page={content} />
      <ArticleFooter
        previous={previous}
        next={next}
        shareImage={{
          src: shareImage?.asset?.url,
          description: summary,
        }}
      />
    </>
  ),
);

export default Article;
